import { formatPhoneNumber } from '@/components/shared/utils/utils';
import { ApplicantInfoProps } from '../Applicant.types';
import { ApplicantInfoCard, ApplicantInfoRow } from './ApplicantInfoCard';

export const ApplicantInformation = ({
    id,
    email,
    phone,
    partnerId,
    referredBy,
    lastPageVisited,
    isSubmission = false,
}: ApplicantInfoProps & { isSubmission?: boolean }) => {
    return (
        <ApplicantInfoCard title="Applicant Information">
            <ApplicantInfoRow label="ID" value={id} data-testid="id" />
            <ApplicantInfoRow label="Partner ID" value={partnerId} data-testid="partner-id" />
            <ApplicantInfoRow label="Email" value={email} data-testid="email" />
            <ApplicantInfoRow
                label="Phone"
                value={formatPhoneNumber(phone)}
                data-testid="phone"
            />
            <ApplicantInfoRow label="Referred By" value={referredBy} data-testid="referred-by" />
            <ApplicantInfoRow
                label="Last Page Visited"
                value={lastPageVisited}
                // Live only on the current application, as a submission never records it.
                isLive={!isSubmission}
                data-testid="last-page-visited"
            />
        </ApplicantInfoCard>
    );
};
